
import React, { useContext, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
} from "@mui/material";


import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import PanoramaIcon from "@mui/icons-material/Panorama";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import InsertEmoticonIcon from "@mui/icons-material/InsertEmoticon";
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import SchoolIcon from "@mui/icons-material/School";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import LogoutIcon from "@mui/icons-material/Logout";
import LoaderComponent from "./LoaderComponent";

import { GlobalContext } from "../context/global_context";
import { services } from "../services/api";

const NavBar = ({ setLogin }) => {
  const navigate = useNavigate();
  const { GlobalState, setGlobalState } = useContext(GlobalContext);
  const logoutInProgress = useRef(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);


  const menuItems = [
    { text: "Slider", icon: <PanoramaIcon /> },
    { text: "Noticias", icon: <NewspaperIcon /> },
    { text: "Registro Usuarios", icon: <InsertEmoticonIcon /> },
    { text: "Disciplinas y Periodos", icon: <InsertInvitationIcon /> },
    { text: "Talleres", icon: <SchoolIcon /> },
    { text: "TPP", icon: <SchoolIcon /> },
    { text: "Inscripciones", icon: <PersonAddIcon /> },
    { text: "Reporte", icon: <LibraryBooksIcon />, hasDivider: true }
  ];

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setGlobalState({ ...GlobalState, navBarOpen: open });
  };

  const handleMenuClick = (viewName) => {
    navigate("/admin");
    setGlobalState({
      ...GlobalState,
      vista: viewName,
      navBarOpen: false,
    });
  };

  const handleLogout = async () => {
    if (logoutInProgress.current) return;
    logoutInProgress.current = true;
    setIsLoggingOut(true);

    try {
      await services("POST", "logout", null);
    } catch (error) {
      console.error("Error al cerrar sesión:", error);
    } finally {
      localStorage.clear();
      document.cookie = 'app_auth_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      if (setLogin) setLogin(null);

      setGlobalState({
        ...GlobalState,
        navBarOpen: false,
      });

      logoutInProgress.current = false;
      setIsLoggingOut(false);
      navigate("/login");
    }
  };

  const list = () => (
    <Box
      sx={{ width: 250 }}
      role="presentation"
      onKeyDown={toggleDrawer(false)}
    >
      {/* Sección Admin */}
      <List>
        <ListItem disablePadding>
          <ListItemButton onClick={() => navigate("/admin")}>
            <ListItemIcon>
              <SupervisorAccountIcon />
            </ListItemIcon>
            <ListItemText primary="Administrador" />
          </ListItemButton>
        </ListItem>
      </List>

      <Divider />

      {/* Sección Dinámica */}
      <List>
        {menuItems.map((item, index) => (
          <React.Fragment key={item.text}>

            {item.hasDivider && <Divider />}

            <ListItem disablePadding>
              <ListItemButton onClick={() => handleMenuClick(item.text)}>
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItemButton>
            </ListItem>
          </React.Fragment>
        ))}
      </List>

      <Divider />

      {/* Sección Cerrar Sesión */}
      <List>
        <ListItem disablePadding className="cerrarSesion">
          <ListItemButton onClick={handleLogout}>
            <ListItemIcon>
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText primary="CERRAR SESIÓN" />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );

  return (
    <div>
      {isLoggingOut && <LoaderComponent message="Cerrando sesión…" />}
      <Drawer
        anchor="left"
        open={GlobalState.navBarOpen}
        onClose={toggleDrawer(false)}
      >
        {list()}
      </Drawer>
    </div>
  );
};

export default NavBar;
